function addClassIsLoaded(element, delay) {
  setTimeout(() => {
    element.classList.add('is-loaded');
  }, delay);
}

function handleWindowLoad(loadingElement, mainElement) {
  window.addEventListener('load', () => {
    const delay = sessionStorage.getItem('isLoaded') ? 1000 : 2000;
    addClassIsLoaded(loadingElement, delay);
    addClassIsLoaded(mainElement, delay + 200);
  });
}

function hideLoading() {
  const loadingElement = document.querySelector('.js-loading');
  const mainElement = document.querySelector('main');
  handleWindowLoad(loadingElement, mainElement);
}

sessionStorage.setItem('isLoaded', true);

document.addEventListener('DOMContentLoaded', () => {
  hideLoading();
});
